import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GridGroupItem, IconComponent } from '@skylab-angular-shared/ui';

export type GridMoveDirection = 'down' | 'up';

@Component({
    selector: 'skl-grid-move-row-cell',
    imports: [IconComponent],
    templateUrl: './grid-move-row-cell.component.html'
})
export class GridMoveRowCellComponent<TItem> {
    @Input() public entity!: TItem | GridGroupItem<TItem>;
    @Input() public items!: (TItem | GridGroupItem<TItem>)[];
    @Output() public onMove = new EventEmitter<GridMoveDirection>();

    public isButtonVisible(direction: GridMoveDirection): boolean {
        const entityIndex = this.items.findIndex(elem => elem === this.entity);
        const next = this.items[entityIndex + 1];
        const prev = this.items[entityIndex - 1];

        if (direction === 'up' && (!prev || this.isGroupItem(prev))) return false;
        if (direction === 'down' && (!next || this.isGroupItem(next))) return false;

        return true;
    }

    private isGroupItem(obj: any): obj is GridGroupItem<TItem> {
        return obj?.groupKey !== undefined;
    }
}
